import axios from "axios";

export interface SurveyResponse {
  id: string;
  type: string;
  options?: string[];
  question: string;
  displayName: string;
  response: string;
}

export interface SDKResponse {
  surveyResponseId: string;
  createdAt: string;
  videoUrl: string;
  thumbnailUrl: string;
  userId: string;
  userMetadata: {
    deviceType: string;
    osType: string;
    version: string;
  };
  surveyResponse: string; // This is a stringified JSON
}

interface ResponseCount {
  captureId: string;
  count: number;
}

interface SaveCaptureResponseParams {
  captureId: string; // Required
  userId: string; // Required
  surveyResponse: Record<string, unknown>; // The user response from surveyJS
  videoContentType?: string;
  userMetadata?: {
    deviceType?: string;
    osType?: string;
    version?: string;
    [key: string]: string | number | boolean | undefined;
  };
  userParams?: {
    [key: string]: string | number | boolean | undefined;
  };
}

export interface SaveCaptureResponseResult {
  captureId: string;
  sdkResponseId: string;
  surveyId: string;
  surveyVersion: string;
  surveyResponseId: string;
  createdAt: string; // date-time
  updatedAt: string; // date-time
}

class MfaSDKResponseService {
  private static instance: MfaSDKResponseService;
  private baseUrl = `${process.env.REACT_APP_API_BASE_URL}/flight-recorder`;

  private constructor() {}

  public static getInstance(): MfaSDKResponseService {
    if (!MfaSDKResponseService.instance) {
      MfaSDKResponseService.instance = new MfaSDKResponseService();
    }
    return MfaSDKResponseService.instance;
  }

  public async getCaptureResponses(
    captureId: string,
    userId: string,
    token: string,
    workspaceId: string,
  ): Promise<SDKResponse[]> {
    try {
      console.log("params", captureId, userId, workspaceId, token);
      // captureId = "19";
      const response = await axios.get<SDKResponse[]>(
        `${this.baseUrl}/sdk-response/capture-method/${captureId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            userid: userId,
            // "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error) {
        console.log("error", error);
        // throw new Error(
        // //   error.response?.data?.message ||
        // //     `Failed to fetch capture responses: ${error.message}`,
        // );
      }
      throw new Error(
        "An unexpected error occurred while fetching capture responses",
      );
    }
  }

  public async getResponseCounts(
    projectId: string,
    workspaceId: string,
    token: string,
  ): Promise<ResponseCount[]> {
    try {
      const response = await axios.get<ResponseCount[]>(
        `${this.baseUrl}/sdk-response/response-count/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // TODO "workspace-id": workspaceId,
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Failed to fetch response counts:", error);
      return [];
    }
  }

  public async saveCaptureResponse(
    params: SaveCaptureResponseParams,
  ): Promise<SaveCaptureResponseResult> {
    try {
      const response = await axios.post(
        `${this.baseUrl}/sdk-response/save`,
        params,
        {
          headers: {},
        },
      );
      return response.data as SaveCaptureResponseResult;
    } catch (error: unknown) {
      console.error("Failed to save capture response:", error);
      throw new Error(
        error instanceof Error
          ? `Failed to save capture response: ${error.message}`
          : "An unexpected error occurred while saving capture response",
      );
    }
  }
}

export default MfaSDKResponseService;
